import React, { useContext } from "react";

const DataContext = React.createContext();

export const DataProvider = ({ children, value }) => {
  const { data, pageContext: context } = value;

  return (
    <DataContext.Provider value={{ data, context }}>
      {children}
    </DataContext.Provider>
  );
};

export const useDataContext = () => useContext(DataContext);
